/*
 * Component <pin-menu>
 */

import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

angular.module('posApp').directive(
  'pinMenu',
  (
    translate,
    // favor pinProvider where possible
    payPlaza,
    pinProvider,
    settingsManager: SettingsManager,
  ) => ({
    restrict: 'E',

    scope: true,

    template: require('./pin-menu.html').default,

    link: function ($scope: any, element, attrs) {
      const $translate = translate;

      // Hack! To be replaced by custom operator rx operator
      const wrapInSafeApply = require('@global/wrap-in-safe-apply')($scope);

      $scope.displayMessage = $translate.instant('PINInsertCard');

      $scope.showTransactionMethods = false;
      $scope.showPINControl = false;
      $scope.pinInProgress = false;
      $scope.canAbort = true;
      $scope.hasCcv = false;
      $scope.paymentMethods = [];
      $scope.selectedMethod = {};

      function resetMethods() {
        $scope.showTransactionMethods = false;
        $scope.showPINControl = true;
        $scope.selectedMethod = {};
        $scope.paymentMethods = [];
      }

      $scope.onSelectMethod = () => {
        payPlaza.setTransactionMethod(
          $scope.selectedMethod.aid,
          $scope.selectedMethod.applicationName,
        );
        resetMethods();
      };

      /**
       * @ngdoc
       * @name posApp.payPlazaController#abortPIN
       * @methodOf posApp.payPlazaController
       * @description
       * OnClick event for the Stop button
       */
      $scope.onAbortPIN = () => {
        $scope.canAbort = false;
        pinProvider.abortTransaction();
      };

      pinProvider.inProgress$.subscribe(
        wrapInSafeApply((status) => {
          $scope.showPINControl = status;
          $scope.pinInProgress = status;

          if (status === true) {
            $scope.canAbort = true;
          }

          // when inProgress becomes false, reset the show transaction methods flag
          if (status === false) {
            $scope.showTransactionMethods = false;
            $scope.canAbort = true;
          }
        }),
      );

      // Subscribe to hasCcv$ to update button state
      pinProvider.hasCcv$.subscribe(
        wrapInSafeApply((hasCcv) => {
          if (hasCcv && settingsManager.settings.pinProvider === 'payNL') {
            $scope.canAbort = false;
            $scope.hasCcv = true;
          } else {
            $scope.canAbort = true;
            $scope.hasCcv = false;
          }
        }),
      );

      payPlaza.showTransactionMethods$.subscribe(
        wrapInSafeApply((transactionMethods) => {
          $scope.showTransactionMethods = true;
          $scope.showPINControl = false;
          $scope.paymentMethods = transactionMethods;

          // Select the first method by default
          if ($scope.paymentMethods.length > 0) {
            $scope.selectedMethod = $scope.paymentMethods[0];
          }
        }),
      );

      // is called with values from pay plaza, examples for which tests were
      // written: 'PINInsertCard', 'WaitingForCustomer', 'Processing', 'Printing'
      // TODO replace with pinProvider as soon as payNl supports it
      payPlaza.update$.subscribe(
        wrapInSafeApply((message) => {
          $scope.displayMessage = $translate.instant(message);
        }),
      );
    },
  }),
);
